const LIGHT_FONT_COLOR = '#ffffff';
const DARK_FONT_COLOR = '#353535';

export function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [];
}

export function getContrastColor(hex) {
  const rgb = hexToRgb(hex);

  const brightness = Math.round(
    (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000
  );

  return brightness > 140 ? DARK_FONT_COLOR : LIGHT_FONT_COLOR;
}
